function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "question");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "UniCafe-PWA-Layouts-MVP",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Info",
  transform: "translate(-32.000000, -506.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Button/Area-Selection-Copy-4",
  transform: "translate(10.000000, 489.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "question",
  transform: "translate(23.000000, 18.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  stroke: "#155C28",
  strokeLinecap: "square",
  cx: 9.5,
  cy: 9.5,
  r: 9.5
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#155C28",
  fillRule: "nonzero",
  cx: 9,
  cy: 15,
  r: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M7,4.52706679 C8.69865121,3.70377754 10.9010571,3.80043903 11.6524304,5.13370098 C12.4038037,6.46696292 11.884839,8.01621331 10.5968574,9.21214927 C9.30887583,10.4080852 8.88117104,11.0587171 8.88117104,12",
  id: "Path",
  stroke: "#155C28",
  strokeLinecap: "square"
})))));

var SvgQuestion = function SvgQuestion(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuestion, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/question.79a638d2.svg";
export { ForwardRef as ReactComponent };